<template>
  <div
    ref="wrapper"
    class="wrapper">
    <main class="main">
      <template v-if="page">
        <template v-for="(module, index) in page.acf.modules">
          <template v-if="module.acf_fc_layout === 'PagesHeroComponent'">
            <PagesHeroComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'VideoComponent'">
            <VideoComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'OpenPositionsComponent'">
            <OpenPositionsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'ArticlesComponent'">
            <ArticlesComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'ValuesCarouselComponent'">
            <ValuesCarouselComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="
              module.acf_fc_layout === 'PatientResourceCenterComponent'
            ">
            <PatientResourceCenterComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'ClinicalTrialsComponent'">
            <ClinicalTrialsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="
              module.acf_fc_layout === 'ImageWithCardsAndTextComponent'
            ">
            <ImageWithCardsAndTextComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'GradientCTAComponent'">
            <GradientCTAComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'ContactUsComponent'">
            <ContactUsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="
              module.acf_fc_layout === 'PrivacyPolicyAndTermsComponent'
            ">
            <PrivacyPolicyAndTermsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'TeamsComponent'">
            <TeamsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'InvestorsComponent'">
            <InvestorsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'ImageCTACountersComponent'">
            <ImageCTACountersComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'SimpleCTASectionComponent'">
            <SimpleCTASectionComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'ImageWithCardsComponent'">
            <ImageWithCardsComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'BlogListComponent'">
            <BlogListComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'ImageComponent'">
            <ImageComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'SpacerComponent'">
            <SpacerComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'AnchorComponent'">
            <AnchorComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-if="module.acf_fc_layout === 'HeroComponent'">
            <HeroComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template
            v-else-if="module.acf_fc_layout === 'GeneralContentComponent'">
            <GeneralContentComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
          <template v-else-if="module.acf_fc_layout === 'PageCalloutComponent'">
            <PageCalloutComponent
              :key="index"
              :data="module"
              :index="index" />
          </template>
        </template>
      </template>
    </main>
  </div>
</template>

<script setup>
import AnchorComponent from '@/components/modules/AnchorComponent.vue'
import BlogListComponent from '@/components/modules/BlogListComponent.vue'
import ImageComponent from '@/components/modules/ImageComponent.vue'
import SpacerComponent from '@/components/modules/SpacerComponent.vue'
import HeroComponent from '@/components/modules/HeroComponent.vue'
import GeneralContentComponent from '@/components/modules/GeneralContentComponent.vue'
import PageCalloutComponent from '@/components/modules/PageCalloutComponent.vue'
import pageStore from '../stores/pageStore'

/* #META
  COMPONENTS - DO NOT ERASE COMMENT
  #ENDMETA */
import VideoComponent from '@/components/modules/VideoComponent.vue'
import OpenPositionsComponent from '@/components/modules/OpenPositionsComponent.vue'
import ArticlesComponent from '@/components/modules/ArticlesComponent.vue'
import ValuesCarouselComponent from '@/components/modules/ValuesCarouselComponent.vue'
import PatientResourceCenterComponent from '@/components/modules/PatientResourceCenterComponent.vue'
import ClinicalTrialsComponent from '@/components/modules/ClinicalTrialsComponent.vue'
import ImageWithCardsAndTextComponent from '@/components/modules/ImageWithCardsAndTextComponent.vue'
import GradientCTAComponent from '@/components/modules/GradientCTAComponent.vue'
import ContactUsComponent from '@/components/modules/ContactUsComponent.vue'
import PrivacyPolicyAndTermsComponent from '@/components/modules/PrivacyPolicyAndTermsComponent.vue'
import TeamsComponent from '@/components/modules/TeamsComponent.vue'
import InvestorsComponent from '@/components/modules/InvestorsComponent.vue'
import ImageCTACountersComponent from '@/components/modules/ImageCTACountersComponent.vue'
import ImageWithCardsComponent from '@/components/modules/ImageWithCardsComponent.vue'
import PagesHeroComponent from '@/components/modules/PagesHeroComponent.vue'
import SimpleCTASectionComponent from './modules/SimpleCTASectionComponent.vue'

const props = defineProps(['slug', 'isHomepage'])

const { page } = pageStore(props.slug)
</script>

<style lang="scss"></style>
